module.exports = __webpack_public_path__ + "static/media/success.517b14d.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/music/success.wav
// module id = VSAw
// module chunks = 176